<template>
  <div>
    <template v-if="$permissionAbility(VISIT_ATTENDANCE_SHOW_ALL, permissions)">
      <b-card-actions title="Filters" action-collapse>
        <div>
          <!-- search input -->
            <div>
              <b-row>
                <b-col
                    md="6"
                    lg="4"
                    xs="12"
                >
                  <v-select
                      v-model="selectEmpId"
                      :options="filterEmpIdOption"
                      :reduce="(item) => item.id"
                      label="name"
                      placeholder="Select Employee"
                      class="mb-1 custom-font"
                      @input="loadReconciliation('user')"
                  >
                    <template #option="data">
                      <UserSelect :user="data" />
                    </template>
                  </v-select>
                </b-col>
                <b-col
                    md="6"
                    lg="4"
                    xs="12"
                >
                  <v-select
                      v-model="selectDivisionId"
                      :options="filterDivisionIdOption"
                      :reduce="(item) => item.id"
                      label="name"
                      placeholder="Select Division"
                      class="mb-1 custom-font"
                      @input="loadReconciliation('division')"
                  />
                </b-col>
                <b-col
                    md="6"
                    lg="4"
                    xs="12"
                >
                  <v-select
                      v-model="selectDepartmentId"
                      :options="filterDepartmentIdOption"
                      :reduce="(item) => item.id"
                      label="name"
                      placeholder="Select Department"
                      class="mb-1 custom-font"
                      @input="loadReconciliation('department')"
                  />
                </b-col>
                <b-col
                    md="6"
                    lg="4"
                    xs="12"
                >
                  <v-select
                      v-model="selectStatus"
                      :options="filterStatusOption"
                      :reduce="(item) => item.id"
                      label="name"
                      placeholder="Select Status"
                      class="mb-1 custom-font"
                      @input="loadReconciliation('status')"
                  />
                </b-col>
                <b-col
                    md="6"
                    lg="4"
                    xs="12"
                >
                  <v-select
                      v-model="selectEmpTypeId"
                      :options="filterEmpTypeIdOption"
                      :reduce="(item) => item.id"
                      label="name"
                      placeholder="Select Employee Types"
                      class="mb-1 custom-font"
                      @input="loadReconciliation('empType')"
                  />
                </b-col>
                <b-col
                    md="2"
                    lg="4"
                    xs="12"
                >

                  <flat-pickr
                      v-model="filterRangeDate"
                      class="form-control"
                      placeholder="Select Date Range"
                      :config="{ mode: 'range'}"
                      @input="loadReconciliation('date')"
                  />
                </b-col>
              </b-row>
            </div>
        </div>
      </b-card-actions>
    </template>

    <b-card>
      <div>
        <!-- search input -->
        <div class="custom-search d-flex align-items-center justify-content-end">
          <div
              class="d-flex flex-column flex-sm-row align-items-center mb-1 justify-content-around"
          >

            <template v-if="
            $permissionAbility(VISIT_ATTENDANCE_APPLY_ALL,permissions)">
              <b-button
                  class="flex-shrink-0"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  v-on:click="showApplyModal('apply-employee')"
              >
                Apply For Employee
              </b-button>
            </template>

            <template v-else>
              <template v-if="$permissionAbility(VISIT_ATTENDANCE_APPLY,permissions)">
                <b-button
                    class="flex-shrink-0 ml-1"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    v-on:click="showApplyModal"
                >
                  Apply
                </b-button>
              </template>
            </template>
          </div>
        </div>
        <!-- table -->
        <vue-good-table
            styleClass="vgt-table table-custom-style condensed striped"
            mode="remote"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            @on-per-page-change="onPerPageChange"
            :totalRows="totalRecords"
            :isLoading.sync="isLoading"
            :rows="rows"
            :sort-options="{
          enabled: false,
          multipleColumns: true,
          initialSortBy: [{ field: 'requested_date', type: 'desc' }],
        }"
            :columns="columns"
            :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"

        >
          <template slot="table-row" slot-scope="props">
            <!-- Column: head -->
            <!-- Column: head -->
            <span v-if="props.column.field === 'name'">

            <template v-if="props.row?.user_id">
              <span class="cursor-pointer" @click="onShowPage(props.row.id)">
                <UserCard :user="props?.row?.user?.data" />
              </span>
            </template>

          </span>

            <template v-if="props.column.field === 'format_company'">
              <p>Company: <b>{{ props.row?.company }}</b></p>
              <p>Contact Person: <b>{{ props.row?.contact_person }}</b></p>
            </template>

            <!-- Column: old_attendance -->
            <template v-if="props.column.field === 'format_requested_time'">


              <!-- first_check_in -->
              <template v-if="props.row?.start_time">
                <div>
                <span>
                  Check In :
                  <b>{{ formatFnTableCheckIn(props.row?.start_time) }}</b>
                </span>
                </div>
              </template>

              <!-- last_check_out -->
              <template v-if="props.row?.end_time">
                <div>
                <span>
                  Check Out :
                  <b>{{ formatFnTableCheckIn(props.row?.end_time) }}</b>
                </span>
                </div>
              </template>

              <template v-if="props.row?.start_time && props.row?.end_time">
                <div>
                <span>
                 Request for:
                   <b><b-badge variant="light-success">
                    {{ formatTimeDff(props.row?.start_time, props.row?.end_time) }} Hours
                  </b-badge></b>

                </span>
                </div>
              </template>

              <template>
                <b-button
                    v-b-tooltip.hover
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary"
                    class="btn-icon"
                    :title='props.row?.description'
                >
                  <feather-icon class="btn-icon" icon="InfoIcon" />
                </b-button>
              </template>
            </template>

            <!-- Column: reconciliation -->
            <span v-if="props.column.field === 'format_status'">
            <b-badge :variant="statusVariant(props.row?.status)">
              <span v-if="props.row?.status === ''">
                Pending
              </span>
              <span v-else>
                {{ props.row?.status.toUpperCase() }}
              </span>
            </b-badge>
            <br />

            <template v-if="props.row?.status !== 'pending'">
              <b-button
                  v-b-tooltip.hover
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="props.row?.status === 'approved' ? 'outline-success' : 'outline-danger'"
                  class="btn-icon mt-1"
                  :title='props.row?.remarks'
              >
                <feather-icon class="btn-icon" icon="InfoIcon" />
              </b-button>
            </template>

          </span>

          <!-- description -->
          <span v-if="props.column.field === 'format_description'">
            <template>
              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon"
                  @click="showDescription(props.row?.description)"
              >
                <feather-icon icon="InfoIcon" />
              </b-button>
            </template>
          </span>

            <!-- Column: Action -->
            <span  v-if="props.column.field === 'action'">

              <span @click="onOpenInNewTab(props.row.id)">
                  <feather-icon
                      v-b-tooltip.hover
                      icon="EyeIcon"
                      class="mr-50 custom-icon cursor-pointer"
                      title="View"
                      size="16"
                  />
                </span>

              <template
                  v-if="props.row?.visiting_completed === 1 && props?.row?.status === 'pending'"
              >

                  <span v-if="checkApprovePermission(props.row)" @click="onApprove(props.row)">
                      <feather-icon
                          v-b-tooltip.hover
                          icon="CheckIcon"
                          class="mr-50 custom-icon cursor-pointer"
                          title="Approve"
                          size="16"
                      />
                  </span>

                  <span v-if="checkRejectPermission(props.row)" @click="rejectModalOpen(props.row)">
                      <feather-icon
                          v-b-tooltip.hover
                          icon="XIcon"
                          class="mr-50 custom-icon cursor-pointer"
                          title="Reject"
                          size="16"
                      />
                  </span>


              </template>


          </span>

            <!-- Column: Common -->
            <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
          </template>

          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Showing 1 to </span>
                <b-form-select
                    v-model="pageLength"
                    :options="['10', '25', '50', '100', '500']"
                    class="mx-1"
                    @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
                />
                <span class="text-nowrap"> of {{ props.total }} entries </span>
              </div>
              <div>
                <b-pagination
                    :value="1"
                    :total-rows="props.total"
                    :per-page="pageLength"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </div>



      <!-- apply modal -->
      <b-modal
          id="modal-apply-form"
          centered
          :title="
        modelType == 'editModel'
          ? 'Visit Attendance Details'
          : 'Visit Attendance Request'
      "
          hide-footer
          @hidden="hiddenApplyModal"
          no-close-on-backdrop
          size="lg"
      >
        <validation-observer ref="applyValidation">
          <b-form v-on:submit.prevent="applyFromSubmit">

            <b-row class="justify-content-center">
              <b-col cols="12" md="8" lg="6">
                <div class="text-center">

                  <template v-if="userData?.user_id">
                    <b-avatar default="''" :src="userData?.user?.data?.avatar === '' ? '/avatar.svg' : userData?.user?.data?.avatar" >
                    </b-avatar>
                      <h4>{{ userData?.user?.data?.name }} <b-badge variant="light-secondary">{{
                          userData?.user?.data?.employee_number
                        }}</b-badge></h4>
                    <a :href="'mailto:' + (userData?.user?.data?.email || '')" class="font-small-2 font-weight-bold">
                      {{ userData?.user?.data?.email }}
                    </a> <br>
                    <b-badge variant="light-primary">
                      {{ userData?.user?.data?.department?.name }}
                    </b-badge> <br>
                    <b-badge variant="light-primary">
                      {{ userData?.user?.data?.designation?.name }}
                    </b-badge>
                  </template>
                </div>
              </b-col>
            </b-row>

          <template v-if="applyEmployee">
            <b-form-group label="Employee" label-for="user-id">
              <ValidationProvider
                  name="employee"
                  v-slot="{ errors }"
                  vid="user_id"
                  rules="required"
              >
                <v-select
                    id="user-id"
                    placeholder="Select Employee"
                    v-model="selectUserId"
                    :options="userIdOption"
                    :reduce="(country) => country.id"
                    label="name"
                    @input=""
                >
                  <template #option="data">
                    <UserSelect :user="data" />
                  </template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </b-form-group>
          </template>

            <!--          <template v-if="applyEmployee">-->
            <!-- attendance date-->
            <b-form-group label="Visit Attendance Date*">
              <ValidationProvider
                  name="date"
                  v-slot="{ errors }"
                  vid="requested_date"
                  rules="required"
              >
                <flat-pickr
                    v-model="attendanceDate"
                    class="form-control"
                    placeholder="Select Date"
                    :state="errors.length > 0 ? false : null"
                    id="attendance-date"
                    :disabled = "(applyEmployee && !selectUserId) || modelType === 'editModel'"
                    :config="attendanceDateConfig"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </b-form-group>
            <!--          </template>-->

            <b-row>
              <b-col cols="6">
                <b-form-group label="Requested Check In*">
                  <validation-provider
                      #default="{ errors }"
                      name="check in"
                      vid="check_in"
                      rules="required"
                  >
                    <flat-pickr
                        name="check-in"
                        id="check_in"
                        v-model="checkIn"
                        class="form-control"
                        placeholder="09:00 AM"
                        :config="{
                          enableTime: true,
                          noCalendar: true,
                          static: true,
                          dateFormat: 'H:i:S',
                          altInput: true,
                          altFormat: 'h:i K',
                          minuteIncrement: 1
                        }"
                        :disabled = "!attendanceDate || modelType === 'editModel'"
                        :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group label="Requested Check Out*">
                  <validation-provider
                    #default="{ errors }"
                    name="check out"
                    vid="check_out"
                    rules="required"
                  >
                    <flat-pickr
                        name="check-out"
                        id="check_out"
                        v-model="checkOut"
                        class="form-control"
                        placeholder="06:00 PM"
                        :config="{
                          enableTime: true,
                          noCalendar: true,
                          static: true,
                          dateFormat: 'H:i:S',
                          altInput: true,
                          altFormat: 'h:i K',
                          minuteIncrement: 1
                        }"
                        :disabled = "!attendanceDate || modelType === 'editModel'"
                        :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- description -->
            <b-form-group
                label="Description*"
                label-for="description"
            >
              <validation-provider
                  #default="{ errors }"
                  name="description"
                  vid="description"
                  rules="required"
              >
                <b-form-textarea
                    id="description"
                    v-model="description"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Description"
                    rows="3"
                    :disabled="modelType === 'editModel'"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
                label="Contact Person"
                label-for="contact_person"
                class="required-label"
            >
              <validation-provider
                  #default="{ errors }"
                  name="contact person"
                  vid="contact_person"
                  rules="required|max:255"
              >
                <b-form-input
                    id="contact_person"
                    type="text"
                    v-model="contact_person"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Enter Contact Person"
                    :disabled = "modelType === 'editModel'"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
                label="Company"
                label-for="company"
                class="required-label"
            >
              <validation-provider
                  #default="{ errors }"
                  name="company"
                  vid="company"
                  rules="required|max:255"
              >
                <b-form-input
                    id="company"
                    type="text"
                    v-model="company"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Enter Company"
                    :disabled = "modelType === 'editModel'"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
                label="Address*"
                label-for="address"
            >
              <validation-provider
                  #default="{ errors }"
                  name="address"
                  vid="address"
                  rules="required"
              >
                <b-form-textarea
                    id="address"
                    v-model="address"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Address"
                    rows="3"
                    :disabled = "modelType === 'editModel'"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>


            <template v-if="modelType == 'editModel'">
              <b-form-group
                  label="Remarks"
                  :class="checkApprovePermission(userData)
                ? 'required-label'
                : ''
            "
                  label-for="remarks"
              >
                <validation-provider
                    #default="{ errors }"
                    name="remarks"
                    vid="remarks"
                    :rules="
                  checkApprovePermission(userData)
                  ? 'required'
                  : ''
              "
                >
                  <b-form-textarea
                      id="required-remarks"
                      v-model="remarks"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Remarks"
                      rows="3"
                      :disabled="!checkApprovePermission(userData)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>

            <!-- loading button -->
            <template v-if="isApplyFormSubmitLoading">
              <b-button class="float-right" variant="primary" disabled>
                <b-spinner small />
                Loading...
              </b-button>
            </template>

            <!-- submit button -->
            <template v-if="!approveButton && !isApplyFormSubmitLoading">
              <b-button
                  type="submit"
                  class="float-right"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
              >
                Submit
              </b-button>
            </template>

            <!-- approve button -->
            <template v-if="approveButton && !isApplyFormSubmitLoading">
              <b-button
                  class="float-right"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="warning"
                  @click="handleApproveClick"
              >
                Approve
              </b-button>
            </template>
          </b-form>
        </validation-observer>
      </b-modal>

    <!-- Reject  -->
    <b-modal
      id="modal-reject-form"
      centered
      title= "Reject Request"
      hide-footer
      @hidden="hiddenRejectModal"
      no-close-on-backdrop
      size="lg"
    >
      <validation-observer ref="rejectValidation">
        <b-form v-on:submit.prevent="rejectFromSubmit">

          <b-row class="justify-content-center">
              <b-col cols="12" md="8" lg="6">
                <div class="text-center">

                  <template v-if="userData?.user_id">
                    <b-avatar default="''" :src="userData?.user?.data?.avatar === '' ? '/avatar.svg' : userData?.user?.data?.avatar" >
                    </b-avatar>
                    <h4>{{ userData?.user?.data?.name }} <b-badge variant="light-secondary">{{
                        userData?.user?.data?.employee_number
                      }}</b-badge></h4>
                    <a :href="'mailto:' + (userData?.user?.data?.email || '')" class="font-small-2 font-weight-bold">
                      {{ userData?.user?.data?.email }}
                    </a> <br>
                    <b-badge variant="light-primary">
                      {{ userData?.user?.data?.department?.name }}
                    </b-badge> <br>
                    <b-badge variant="light-primary">
                      {{ userData?.user?.data?.designation?.name }}
                    </b-badge>
                  </template>
                </div>
              </b-col>
            </b-row>

          <!-- description -->
          <b-form-group
            label="Rejection Remarks*"
            label-for="rejection_remarks"
          >
            <validation-provider
              #default="{ errors }"
              name="Rejection Remarks"
              vid="rejection_remarks"
              rules="required"
            >
              <b-form-textarea
                id="rejection_remarks"
                v-model="rejectionRemarks"
                :state="errors.length > 0 ? false : null"
                placeholder="Rejection Remarks"
                rows="3"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- submit button -->
          <template >
            <b-button
              type="submit"
              class="float-right"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
            >
              Submit
            </b-button>
          </template>


        </b-form>
      </validation-observer>
    </b-modal>

    <!-- RECONCILIATION modal -->
    <template>
      <b-modal
        id="modal-description-view"
        centered
        :title="isPopUpDescription ? 'Description' : 'Remarks'"
        hide-footer
        @hidden="hiddenDescriptionModal"
        no-close-on-backdrop
      >
        {{ description }}
      </b-modal>
    </template>
  </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BForm,
  BModal,
  BSpinner,
  BCol,
  BRow,
  BFormDatepicker,
  BLink,
  BFormTextarea,
  BFormTimepicker,
  BTable, VBTooltip,
} from 'bootstrap-vue'
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, max, size } from "@validations";
import flatPickr from 'vue-flatpickr-component';


import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapGetters } from "vuex";
import { formatDateRange, minutesToHours } from '@/helpers/helpers'
import {
  APPROVED,
  CANCELED,
  PENDING,
} from "@/helpers/constant/attendanceConstant";

import {
  VISIT_ATTENDANCE_APPLY_ALL,
  VISIT_ATTENDANCE_APPLY,
  VISIT_ATTENDANCE_SELF_APPROVE,
  VISIT_ATTENDANCE_MANAGE_DEPARTMENT,
  VISIT_ATTENDANCE_MANAGE_DIVISION,
  VISIT_ATTENDANCE_SHOW_ALL, VISIT_ATTENDANCE_APPROVE, VISIT_ATTENDANCE_REJECT
} from '@/helpers/permissionsConstant'
import UserCard from "@/layouts/components/UserCard.vue";
import UserSelect from '@/layouts/components/UserSelect.vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { REJECTED } from '@/helpers/constant/leaveRequestStatusConstant'

export default {
  name: "ReconciliationView",
  components: {
    BCardActions,
    UserSelect,
    BForm,
    BButton,
    BCard,
    UserCard,
    VueGoodTable,
    flatPickr,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BSpinner,
    BCol,
    BRow,
    BFormDatepicker,
    BLink,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BFormTimepicker,
    BTable
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },

  async created() {

    try {

      const currentDate = new Date()

      const todaysDate = `${currentDate.getFullYear()}-${(
          currentDate.getMonth() + 1
      )
          .toString()
          .padStart(2, '0')}-${currentDate
          .getDate()
          .toString()
          .padStart(2, '0')}`

      this.filterStartDate = todaysDate
      this.filterEndDate = todaysDate

      const [employeeTypes, divisions, departments, employees] = await Promise.all([
        this.getEmployeeTypes(),
        this.getDivisions(),
        this.getDepartments(),
        this.getActiveEmployees(),
      ])

      // employee type
      this.filterEmpTypeIdOption = (employeeTypes?.data?.data || []).map(
          item => {
            const name = item?.name
            return {
              name,
              id: item?.id,
            }
          },
      )

      // department
      this.filterDepartmentIdOption = (departments?.data?.data || []).map(
          item => {
            const name = item?.name

            return {
              name,
              divisionId: item?.division_id,
              id: item?.id,
            }
          },
      )

      // division
      this.filterDivisionIdOption = (divisions?.data?.data || []).map(
          item => {
            const name = item?.name
            return {
              name,
              id: item?.id,
            }
          },
      )

      // employee
      this.filterEmpIdOption = (employees?.data?.data || []).map((item) => {
        return {
          avatar: item?.avatar,
          name: item?.name,
          email: item?.email,
          mobile: item?.mobile,
          employee_number: item?.employee_number,
          id: item?.id,
          departmentId: item?.department_id
        }
      })

      this.userIdOption = this.filterEmpIdOption

    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          icon: "BellIcon",
          variant: "danger",
          text: error?.response?.data?.message,
        },
      });
    }

  },

  data() {
    return {
      VISIT_ATTENDANCE_APPLY_ALL,
      VISIT_ATTENDANCE_APPLY,
      VISIT_ATTENDANCE_SELF_APPROVE,
      VISIT_ATTENDANCE_SHOW_ALL,
      VISIT_ATTENDANCE_APPROVE,
      VISIT_ATTENDANCE_REJECT,
      VISIT_ATTENDANCE_MANAGE_DEPARTMENT,
      VISIT_ATTENDANCE_MANAGE_DIVISION,
      APPROVED,
      CANCELED,
      PENDING,
      REJECTED,

      applyEmployee: false,
      $userId: "",
      selectStatus: "",
      filterStatusOption: [
        {
          id: 'Pending',
          name: 'Pending'
        },
        {
          id: 'Approved',
          name: 'Approved'
        },
        {
          id: 'Rejected',
          name: 'Rejected'
        },
      ],
      filterEmpTypeIdOption: [],
      selectEmpTypeId: '',
      filterDivisionIdOption: [],
      selectDivisionId: '',
      filterDepartmentIdOption: [],
      selectDepartmentId: '',
      filterEmpIdOption: [],
      selectEmpId: '',
      filterStartDate: '',
      filterEndDate: '',
      todaysDate: '',

      filterRangeDate: null,
      userIdOption: [],
      selectUserId: "",

      // apply form
      attendanceDate: "",
      description: "",
      address: "",
      contact_person: "",
      company: "",

      isApplyFormSubmitLoading: false,
      checkIn: "",
      checkOut: "",
      modelType: "",
      approvalRemarks: "",
      approveButton: false,
      timePicker: null,

      attendanceDateConfig: { minDate: 'today', static: true },

      // end apply form

      rejectionRemarks: "",
      rejectReconciliationId: "",
      userData: "",

      // reconciliation form
      remoteAttendanceRequestId: "",
      firstCheckIn: "",
      lastCheckOut: "",
      expectedDutyHours: "",
      totalWorkedHours: "",
      overTimeHours: "",
      remarks: "",
      isUpdateReconciliationFormSubmitLoading: false,
      // end reconciliation form
      fields: ["check_in", "check_out", "worked_hour"],
      items: [],
      pageLength: 10,
      columns: [
        {
          label: "Date",
          field: "requested_date",
          formatFn: this.formatDate,
          sortable: true,
        },
        {
          label: "Company",
          field: "format_company",
          sortable: false,
        },
        {
          label: "Name",
          field: "name",
          sortable: false,
        },
        {
          label: "Requested Time",
          field: "format_requested_time",
          sortable: false,
        },
        {
          label: "Status",
          field: "format_status",
          sortable: false,
        },
        {
          label: "Action",
          field: "action",
          sortable: false,
        },
      ],
      isPopUpDescription: false,
      rows: [],
      delayTimer: null,
      isLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [{ field: "start_time", type: "desc" }],
        page: 1,
        perPage: 10,
      },
    };
  },

  computed: {
    ...mapGetters({
      permissions: "userModule/getPermissions",
      authUser: "userModule/getUser",
    }),
  },

  methods: {

    checkApprovePermission(data) {
      if (
          (data.user_id === this.authUser?.id &&
              this.$permissionAbility(VISIT_ATTENDANCE_SELF_APPROVE, this.permissions))
          ||
          this.$permissionAbility(VISIT_ATTENDANCE_APPROVE, this.permissions)
          ||
          this.validateDeptOrDivisionHead(data.user)
      ) {
        return true;
      }

      return false;
    },

    checkRejectPermission(data) {
      if (
          // 1) The requester is acting on their own record *and* they have
          //    the “self‑reject” permission.
          (data.user_id === this.authUser?.id &&
              this.$permissionAbility(VISIT_ATTENDANCE_SELF_APPROVE, this.permissions))
          ||
          // 2) They hold the global “reject” permission.
          this.$permissionAbility(VISIT_ATTENDANCE_REJECT, this.permissions)
          ||
          // 3) They’re the user’s department or division head.
          this.validateDeptOrDivisionHead(data.user)
      ) {
        return true;
      }

      return false;
    },

    validateDeptOrDivisionHead(user)
    {
      if(user?.data?.id === this.authUser?.id)
      {
        return false
      }

      if(this.$permissionAbility(VISIT_ATTENDANCE_MANAGE_DEPARTMENT, this.permissions) && user?.data?.department?.head?.id === this.authUser?.id)
      {
        return true
      }

      return this.$permissionAbility(VISIT_ATTENDANCE_MANAGE_DIVISION, this.permissions) && user?.data?.department?.division?.head?.id === this.authUser?.id;
    },

    async loadReconciliation(value) {
      if (value === 'division') {
        this.selectDepartmentId = ''
        this.selectEmpId = ''
        if (this.selectDivisionId) {
          const departments = await this.getDepartments()

          this.filterDepartmentIdOption = (departments?.data?.data || []).map(
              item => {
                const name = item?.name

                return {
                  name,
                  divisionId: item?.division_id,
                  id: item?.id,
                }
              },
          )

          this.filterDepartmentIdOption = this.filterDepartmentIdOption.filter(
              item => item?.divisionId === this.selectDivisionId,
          )
        } else {
          const departments = await this.getDepartments()

          this.filterDepartmentIdOption = (departments?.data?.data || []).map(
              item => {
                const name = item?.name

                return {
                  name,
                  divisionId: item?.division_id,
                  id: item?.id,
                }
              },
          )
        }
      }

      if (value === 'department') {
        this.selectEmpId = ''
        if (this.selectDepartmentId) {
          const employees = await this.getActiveEmployees()

          this.filterEmpIdOption = (employees?.data?.data || []).map(item => {
            const name = `${item?.name} (${item?.email})`
            return {
              avatar: item?.avatar,
              name: item?.name,
              email: item?.email,
              mobile: item?.mobile,
              employee_number: item?.employee_number,
              id: item?.id,
              departmentId: item?.department_id,
            }
          })

          this.filterEmpIdOption = this.filterEmpIdOption.filter(
              item => item?.departmentId === this.selectDepartmentId,
          )
        } else {
          const employees = await this.getActiveEmployees()

          this.filterEmpIdOption = (employees?.data?.data || []).map(item => ({
            avatar: item?.avatar,
            name: item?.name,
            email: item?.email,
            mobile: item?.mobile,
            employee_number: item?.employee_number,
            id: item?.id,
            departmentId: item?.department_id,
          }))
        }
      }

      await this.loadItems()
    },

    formattedTime(value) {
      if (value == 0) return "";
      return this.$moment
        .utc(value * 60 * 1000) // Convert minutes to milliseconds
        .format("H:mm");
    },

    async getUsers() {
      return await this.$api.get("api/users/all?include=designation");
    },

    async onShow(value) {
      this.modelType = "editModel";
      this.remoteAttendanceRequestId = value?.id;
      this.attendanceDate = value?.requested_date;
      this.checkIn = value?.start_time;
      this.checkOut = value?.end_time;
      this.description = value?.description;
      this.remarks = value?.remarks;
      this.contact_person = value?.contact_person;
      this.address = value?.address;
      this.userData = value;

      this.$bvModal.show("modal-apply-form");
    },

    applyFromSubmit() {
      this.$refs.applyValidation.validate().then(async (success) => {
        if (success) {
          try {
            if (this.modelType == "editModel") {

              try {
                await this.$api.post(
                  `api/remote-attendances/${value?.id}/status`, {
                      remarks: this.remarks,
                      status: 'approved',
                    }
                )

                this.resetForm()
                this.loadItems()

                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "success",
                    text: "Successfully Approved",
                  },
                });
              } catch (error) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Error",
                    icon: "BellIcon",
                    variant: "danger",
                    text: error?.response?.data?.message,
                  },
                });
              }
            } else {

              this.isApplyFormSubmitLoading = true
              await this.$api.post("api/remote-attendances/apply", {
                requested_date: this.attendanceDate,
                description: this.description,
                start_time: this.checkIn,
                end_time: this.checkOut,
                address: this.address,
                contact_person: this.contact_person,
                company: this.company,
                user_id: this.selectUserId
              });

              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Success",
                  icon: "BellIcon",
                  variant: "success",
                  text: "Visit Attendance Successfully Applied",
                },
              });
            }

            this.hiddenApplyModal();

            this.loadItems();
          } catch (error) {
            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: error?.response?.data?.message,
                },
              });
            }

            if (error?.response?.data?.errors) {
              this.$refs.applyValidation.setErrors(
                error?.response?.data?.errors
              );
            }
          } finally {
            this.isApplyFormSubmitLoading = false;
          }
        }
      });
    },

    statusVariant(value) {
      if (value === 'approved') {
        return "light-success";
      } else if (value === 'rejected') {
        return "light-danger";
      } else if (value === 'pending' || value === '') {
        return "light-warning";
      }
      return "light-warning";
    },

    showDescription(value) {
      this.isPopUpDescription = true;
      this.description = value;
      this.showDescriptionModal();
    },

    async onApprove(value) {
      //create a flag
      this.approveButton = true;

      await this.onShow(value);
    },

    handleApproveClick() {
      this.$swal({
        title: "Warning!",
        text: "Are You Sure You Want To Approve This?",
        icon: "warning",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Ok",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {

            this.isApplyFormSubmitLoading = true

            await this.$api.post(
              `api/remote-attendances/${this.remoteAttendanceRequestId}/status`,
              {
                status: 'approved',
                remarks: this.remarks,
              }
            );

            this.resetForm()

            this.isApplyFormSubmitLoading = false

            // Assuming 'loadItems' is a method to fetch updated data
            await this.loadItems();

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: "Successfully Approved",
              },
            });
            this.hiddenApplyModal();
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: error?.response?.data?.message || "An error occurred",
              },
            });
          } finally {
            this.isApplyFormSubmitLoading = false;
          }
        }
      });
    },

    rejectModalOpen(data) {
      this.$bvModal.show("modal-reject-form");
      this.userData = data;
      this.rejectReconciliationId = data?.id;
    },

    async rejectFromSubmit() {
      this.$refs.rejectValidation.validate().then(async (success) => {
        if (success) {
          try {
            this.$swal({
              title: "Warning!",
              text: `Are You Sure, You Want to Reject Request of ${this.userData?.user?.data?.name}?`,
              icon: "warning",
              customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-outline-danger ml-1",
              },
              buttonsStyling: false,
              showCancelButton: true,
              confirmButtonText: "Ok",
              showLoaderOnConfirm: true,
            }).then(async (result) => {
              if (result.isConfirmed) {
                await this.$api.post(
                  `api/remote-attendances/${this.rejectReconciliationId}/status`,
                  {
                    status: 'rejected',
                    remarks: this.rejectionRemarks,
                  }
                );

                this.$bvModal.hide("modal-reject-form");
                this.rejectionRemarks = ''

                this.loadItems();

                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "success",
                    text: "Successfully Rejected",
                  },
                });
              }
            });
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: error?.response?.data?.message,
              },
            });
          }
        }
      });
    },

    async getActiveEmployees() {
      return await this.$api.get("api/users/active-all");
    },
    async getDivisions() {
      return await this.$api.get("api/divisions/all");
    },
    async getEmployeeTypes() {
      return await this.$api.get("api/employee-types/all");
    },
    async getDepartments() {
      return await this.$api.get("api/departments/all");
    },

    formatFnTableCheckIn(value) {
      if (value) {
        return this.$moment(value, "HH:mm:ss").format("LT");
      }
    },
    formatTimeDff(checkin, checkout) {
      if (checkin && checkout) {
        // Parse the time strings using moment
        const checkInTime = this.$moment(checkin, "HH:mm:ss");
        const checkOutTime = this.$moment(checkout, "HH:mm:ss");

        // Calculate the difference in minutes
        const differenceInMinutes = checkOutTime.diff(checkInTime, 'minutes');

        return minutesToHours(differenceInMinutes)
      }
    },

    showModal() {
      this.$bvModal.show("modal-update-reconciliation-view");
    },
    hiddenModal() {
      this.$bvModal.hide("modal-update-reconciliation-view");
      this.resetForm();
    },
    showDescriptionModal() {
      this.$bvModal.show("modal-description-view");
    },
    hiddenDescriptionModal() {
      this.description = "";
      this.$bvModal.hide("modal-description-view");
    },

    showApplyModal(type) {
      if (type === "apply-employee") {
        this.modelType = "";
        this.applyEmployee = true;
      }
      this.$bvModal.show("modal-apply-form");
    },
    hiddenApplyModal() {
      this.$bvModal.hide("modal-apply-form");
      this.resetForm();
      this.approveButton = false;
      this.applyEmployee = false;
      this.selectUserId = "";
    },
    hiddenRejectModal() {
      this.$bvModal.hide("modal-reject-form");
      this.rejectionRemarks = "";
      this.rejectReconciliationId = "";
      this.userData = "";
    },

    resetForm() {
      this.modelType = ''
      this.attendanceDate = "";
      this.contact_person = "";
      this.address = "";
      this.description = "";
      this.checkOut = "";
      this.checkIn = "";
      this.selectUserId = "";
      this.remarks = "";
    },

    onShowPage(id) {
      this.$router.push({
        name: "visit-attendance-details",
        params: { id },
      });
    },

    onOpenInNewTab(id)
    {
      this.$router.push({ name: 'visit-attendance-details', params: { id } });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    async getAttendances(params) {
      return await this.$api.get(
        "api/remote-attendances?include=user",
        {
          params: {
            show: params.show,
            page: params.page,
            sort: params.sort,
            filterStatus: params.filterStatus,
            filterDivisionId: params.filterDivisionId,
            filterEmpTypeId: params.filterEmpTypeId,
            filterDepartmentId: params.filterDepartmentId,
            filterEmpId: params.filterEmpId,
            filterStartDate: params.filterStartDate,
            filterEndDate: params.filterEndDate,
          },
        }
      );
    },
    async loadItems() {
      try {

        const { startDate, endDate } = formatDateRange(this.filterRangeDate)

        const [attendances] = await Promise.all([
          this.getAttendances({
            show: this.serverParams.perPage,
            page: this.serverParams.page,
            sort: this.serverParams.sort,
            filterStatus: this.selectStatus,
            filterDivisionId: this.selectDivisionId,
            filterEmpTypeId: this.selectEmpTypeId,
            filterDepartmentId: this.selectDepartmentId,
            filterEmpId: this.selectEmpId,
            filterStartDate: startDate,
            filterEndDate: endDate,
          }),
        ]);

        const data = attendances?.data?.data;
        const meta = attendances?.data?.meta;

        this.totalRecords = meta?.pagination?.total;
        this.rows = data;
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: error?.response?.data?.message,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.table-custom-style {
  font-size: 14px !important;
  white-space: nowrap !important;
  min-height: 140px !important;
  tr,
  th,
  td {
    vertical-align: middle !important;
  }
}
.custom-font {
  font-size: 13px !important;
}
.required-label label::after {
  content: " *";
  color: red;
}

.flatpickr-wrapper{
  width: 100% !important;
}

.flatpickr-input[readonly]:disabled {
  color: #d3d3d3 !important; /* Custom color (light gray in this case) */
  background-color: transparent !important;
  cursor: not-allowed;
}

</style>
